export const ChevronUp = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        style={{ verticalAlign }}
        width={size}
        height={size}
        fill='none'
        viewBox='0 0 24 24'
        transform='rotate(180)'
      >
        <path fill='currentColor' fillRule='evenodd' d='M7 10l5 5 5-5' clipRule='evenodd'></path>
        <path stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5' d='M7 10l5 5 5-5H7z'></path>
      </svg>
    </span>
  );
};
